import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Link from "../components/Link"
import Seo from "../components/seo"
import { FormattedMessage } from "react-intl"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const BlogPage = props => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulBlogPost(sort: { publishDate: DESC }) {
          edges {
            node {
              title
              id
              node_locale
              slug
              publishDate(formatString: "Do MMMM, YYYY")
              heroImage {
                gatsbyImageData(width: 460)
                title
                description
              }
              short {
                childMarkdownRemark {
                  excerpt(pruneLength: 100)
                }
              }
            }
          }
        }
      }
    `
  )
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Layout location={props.location}>
      <Seo title="Blog" lang="da-DK" pathname="blog" />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>

      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <h1>Indsigt</h1>
            <div className="blog-grid">
              {data.allContentfulBlogPost.edges.map(edge => {
                if (edge.node.node_locale.toLowerCase() !== "da-dk") {
                  return null
                }
                return (
                  <div className="card" key={edge.node.id}>
                    <h4>
                      <Link to={`/blog/${edge.node.slug}/`}>
                        {edge.node.title}
                      </Link>
                    </h4>
                    <p className="excerpt">
                      {edge.node.short.childMarkdownRemark.excerpt}{" "}
                      <Link to={`/blog/${edge.node.slug}/`}>
                        <FormattedMessage id="readMore" />
                      </Link>
                    </p>
                    <div className="blog-grid-image">
                      <Link to={`/blog/${edge.node.slug}/`}>
                        {edge.node.heroImage && (
                          <GatsbyImage
                            image={getImage(edge.node.heroImage)}
                            alt={edge.node.heroImage.title}
                            className="featured"
                          />
                        )}
                      </Link>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BlogPage
